/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

 /* tslint:disable:max-line-length */

export const dataText = [
    {
        area: 0,
        heading: 'Explore',
        text: 'Roll over the vineyard blocks to discover what each varietal component contributes to the final blend of Col Solare.'
    },
    {
        area: 1,
        heading: 'Malbec',
        text: 'This varietal is prized for its spice notes and deep, rich color.'
    },
    {
        area: 2,
        heading: 'Petit Verdot',
        text: 'Used in the blend to enhance aromatics, depth, and color.'
    },
    {
        area: 3,
        heading: 'Cabernet Sauvignon',
        text: 'The base varietal for Col Solare, Cabernet Sauvignon offers power, dark fruit flavors, and structure to the final blend.'
    },
    {
        area: 4,
        heading: 'Merlot',
        text: 'This fruit-forward varietal contributes complexity and berry flavors.'
    },
    {
        area: 5,
        heading: 'Cabernet Franc',
        text: 'Offers texture, spice, and complexity.'
    },
    {
        area: 6,
        heading: 'Syrah',
        text: 'Contributes to the texture, richness, and overall mouthfeel of the final blend.'
    },
    {
        area: 7,
        heading: 'Carmenere',
        text: 'Rarely planted in Washington state, Carmenere adds spice and complexity when blended with other varietals.'
    },
];

export const dataSvg = [
    {
        area: 3,
        path: {
            d: 'M390.185,2.826L349.474,2.507C349.472,2.713,349.466,2.922,349.466,3.13C349.466,12.431000000000001,350.111,21.581,351.329,30.547L391.71000000000004,24.506C390.73,17.415,390.205,10.18,390.185,2.826Z'
        },
        text: {
            transform: 'matrix(1,0,0,1,430.588,96.527)',
            tspan: [
                {
                    content: 'cs 02',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M392.373,27.841L352.021,34.212C353.408,42.861000000000004,355.345,51.32300000000001,357.796,59.569L396.775,46.925000000000004C394.931,40.712,393.457,34.344,392.373,27.841Z'
        },
        text: {
            transform: 'matrix(0.9903,-0.1392,0.1392,0.9903,434.398,123.705)',
            tspan: [
                {
                    content: 'cs 06',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M401.337,59.06L394.704,60.943000000000005L393.57300000000004,54.660000000000004L399.08900000000006,53.003C398.69800000000004,51.889,398.29600000000005,50.778999999999996,397.93100000000004,49.651L358.742,61.688C361.894,71.688,365.81,81.349,370.41200000000003,90.60900000000001L406.94100000000003,71.68100000000001C404.888,67.574,403.033,63.358,401.337,59.06Z'
        },
        text: {
            transform: 'matrix(0.9397,-0.342,0.342,0.9397,442.8415,150.13)',
            tspan: [
                {
                    content: 'cs 08',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M408.638,74.984L372.55199999999996,94.794C376.79999999999995,102.85499999999999,381.566,110.6,386.82699999999994,117.967L419.26099999999997,92.314C415.365,86.785,411.818,80.997,408.638,74.984Z'
        },
        text: {
            transform: 'matrix(0.866,-0.5,0.5,0.866,455.9065,176.4755)',
            tspan: [
                {
                    content: 'cs 10',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M421.644,95.611L389.046,121.01C392.944,126.26,397.089,131.314,401.468,136.151L432.06600000000003,108.23500000000001C428.382,104.212,424.904,99.998,421.644,95.611Z'
        },
        text: {
            transform: 'matrix(0.7431,-0.6691,0.6691,0.7431,470.556,195.881)',
            tspan: [
                {
                    content: 'cs 21',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M436.515,112.906L407.08099999999996,142.096C408.79799999999994,143.847,410.53999999999996,145.56900000000002,412.31699999999995,147.255L441.36199999999997,117.588C439.714,116.06,438.097,114.501,436.515,112.906Z'
        },
        text: {
            transform: 'matrix(0.7193,-0.6947,0.6947,0.7193,484.2215,210.0805)',
            tspan: [
                {
                    content: 'cs 21',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 4,
        path: {
            d: 'M445.099,120.955L416.904,151.458C424.465,158.195,432.53499999999997,164.37199999999999,441.052,169.921L463.75300000000004,134.956C457.191,130.741,450.96,126.057,445.099,120.955Z'
        },
        text: {
            transform: 'matrix(0.6428,-0.766,0.766,0.6428,500.3285,225.438)',
            tspan: [
                {
                    content: 'mer 01',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 5,
        path: {
            d: 'M466.462,136.651L444.308,171.99400000000003C451.996,176.79400000000004,460.02299999999997,181.09600000000003,468.359,184.84200000000004L485.558,146.67200000000003C478.943,143.752,472.568,140.403,466.462,136.651Z'
        },
        text: {
            transform: 'matrix(0.4226,-0.9063,0.9063,0.4226,524.933,240.7465)',
            tspan: [
                {
                    content: 'cf 04',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 1,
        path: {
            d: 'M322.396,0.375H10.939L10.001,48.628H328.231C324.81,33.107,322.785,16.972,322.396,0.375Z'
        },
        text: {
            transform: 'matrix(1,0,0,1,229.116,104.5015)',
            tspan: [
                {
                    content: 'Malbec, clone 09',
                    dy: '-2.8515625'
                },
                {
                    content: '1.87 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M198.8,60.5L20.5,60.5L9.7,65.7L8.3,135L7.8,161.3L264.5,60.5L198.8,60.5Z'
        },
        text: {
            transform: 'matrix(1,0,0,1,143,172)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon',
                    dy: '-9.453125'
                },
                {
                    content: 'clone 191',
                    dy: '13.2',
                    x: '0'
                },
                {
                    content: '1.62 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M7.176,193.863L332.388,64.8C331.91499999999996,63.183,331.43899999999996,61.57,330.99699999999996,59.937999999999995H264.47399999999993L7.818,160.792L7.176,193.863Z'
        },
        text: {
            transform: 'matrix(0.9272,-0.3746,0.3746,0.9272,210,200)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon, clone 08, 1.19 acres',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M217.617,314.149L382.39,155.071C362.378,132.923,346.46999999999997,106.148,336.078,76.292L121.71399999999997,161.661C143.419,218.865,176.256,270.584,217.617,314.149Z'
        },
        text: {
            transform: 'matrix(1,0,0,1,312.052,275.2205)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon',
                    dy: '-9.453125'
                },
                {
                    content: 'clone 21',
                    dy: '13.2',
                    x: '0'
                },
                {
                    content: '3.96 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M387.826,160.86L222.941,319.635C241.082,338.114,260.785,355.053,281.825,370.253C307.122,347.921,423.87,233.076,451.93399999999997,205.42999999999998C428.041,195.124,406.343,179.895,387.826,160.86Z'
        },
        text: {
            transform: 'matrix(0.7193,-0.6947,0.6947,0.7193,397.4375,345.5565)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon',
                    dy: '-9.453125'
                },
                {
                    content: 'clone 08',
                    dy: '13.2',
                    x: '0'
                },
                {
                    content: '2.34 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 5,
        path: {
            d: 'M461.691,209.322C458.402,208.117,455.15,206.814,451.93499999999995,205.428C423.8709999999999,233.074,307.121,347.91999999999996,281.8259999999999,370.254C294.5799999999999,379.464,307.82499999999993,388.04,321.5199999999999,395.923L424.6669999999999,296.51099999999997L461.691,209.322Z'
        },
        text: {
            transform: 'matrix(0.7071,-0.7071,0.7071,0.7071,424,400)',
            tspan: [
                {
                    content: 'Cabernet Franc',
                    dy: '-2.8515625'
                },
                {
                    content: 'clone 04a, 1.04 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 7,
        path: {
            d: 'M489.703,292.532L489.703,315.15M458.414,346.81L458.414,314.774M458.414,314.774L533.81,314.774M436.925,280.847V351.342H480.466C480.466,351.342,470.476,350.587,467.083,342.483C467.083,342.483,455.77200000000005,343.802,451.43800000000005,336.64C447.10200000000003,329.477,442.391,327.404,442.391,327.404L440.88300000000004,321.561C440.88300000000004,321.561,439.37500000000006,316.65999999999997,443.14500000000004,311.572C446.915,306.482,445.78400000000005,303.843,445.78400000000005,303.843L447.85600000000005,301.77000000000004C447.85600000000005,301.77000000000004,444.84000000000003,299.69700000000006,447.66700000000003,290.83700000000005C450.495,281.98,450.11800000000005,284.24000000000007,449.93100000000004,280.65900000000005L436.925,280.847ZM540.972,274.438V340.033H522.5L519.107,334.567V326.463L511.00199999999995,329.28900000000004L509.68199999999996,324.76700000000005L511.94599999999997,320.2420000000001C511.94599999999997,320.2420000000001,528.3439999999999,317.0390000000001,525.8929999999999,295.7390000000001C525.892,295.737,538.898,290.647,540.972,274.438Z'
        },
        text: {
            transform: 'matrix(1,0,0,1,548.9485,355)',
            tspan: [
                {
                    content: 'Carmenere',
                    dy: '-2.8515625'
                },
                {
                    content: '0.49 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 5,
        path: {
            d: 'M523.5,372.5L521.7,544.4L552.3,544.5L554.5,373C552,373.1,549.5,373.1,547,373.1C539.1,373.1,531.3,373,523.5,372.5L523.5,372.5Z'
        },
        text: {
            transform: 'matrix(0,-1,1,0,597,538.5)',
            tspan: [
                {
                    content: 'Cab Franc',
                    dy: '-2.8515625'
                },
                {
                    content: 'clone 214, 0.52 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 6,
        path: {
            d: 'M502.2,370.6C505.9,371,509.7,371.4,513.4,371.8L513.4,371.8C516.7,372.1,520,372.3,523.4,372.6L523.4,372.6L521.6,544.6L510.2,544.6L500.7,544.6L502.2,370.6'
        },
        text: {
            transform: 'matrix(0,-1,1,0,572.05,537.6)',
            tspan: [
                {
                    content: 'Syrah, clone 77, 0.381 acres',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 6,
        path: {
            d: 'M502.2,370.5L500.7,544.4L467.9,544.3L471.3,365.6C481.5,367.6,491.8,369.3,502.2,370.5'
        },
        text: {
            transform: 'matrix(0,-1,1,0,544,535)',
            tspan: [
                {
                    content: 'Syrah',
                    dy: '-2.8515625'
                },
                {
                    content: 'clone 525, 0.92 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 5,
        path: {
            d: 'M376.785,543.263L455.894,543.587L459.343,362.206C457.69100000000003,361.809,456.036,361.41400000000004,454.392,360.995L376.785,543.263Z'
        },
        text: {
            transform: 'matrix(0.3746,-0.9272,0.9272,0.3746,484,565)',
            tspan: [
                {
                    content: 'Cabernet Franc',
                    dy: '-2.8515625'
                },
                {
                    content: 'clone 04b, 0.98 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M414.269,348.308L330.89,543.076L376.78499999999997,543.263L454.39199999999994,360.995C440.701,357.503,427.31,353.262,414.269,348.308Z'
        },
        text: {
            transform: 'matrix(0.3907,-0.9205,0.9205,0.3907,452.641,525.7855)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon',
                    dy: '-2.8515625'
                },
                {
                    content: 'clone 08, 1.06 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 4,
        path: {
            d: 'M367.277,431.665C359.24199999999996,428.338,351.334,424.771,343.53499999999997,421.016L215.623,543.812L319.53499999999997,544.095L367.277,431.665ZM371.849,420.896L391.247,375.21000000000004L352.653,412.261C358.976,415.277,365.371,418.166,371.849,420.896Z'
        },
        text: {
            transform: 'matrix(0.7071,-0.7071,0.7071,0.7071,363.435,565)',
            tspan: [
                {
                    content: 'Merlot, clone 15, 1.15 acres',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 4,
        path: {
            d: 'M312.501,404.615L168.211,543.682L215.62300000000002,543.812L343.535,421.016C332.96,415.928,322.613,410.456,312.501,404.615ZM391.248,375.21L424.668,296.514L321.52,395.923C331.656,401.758,342.044,407.204,352.654,412.261L391.248,375.21Z'
        },
        text: {
            transform: 'matrix(0.7193,-0.6947,0.6947,0.7193,320,557)',
            tspan: [
                {
                    content: 'Merlot, clone 01, 1.1 acres',
                    dy: '3.75'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M213.784,328.451L0.568,533.769L0.38199999999999995,543.224L168.21,543.682L312.501,404.616C276.244,383.668,243.049,358.016,213.784,328.451Z'
        },
        text: {
            transform: 'matrix(1,0,0,1,250,516.0665)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon',
                    dy: '-9.453125'
                },
                {
                    content: 'clone 02',
                    dy: '13.2',
                    x: '0'
                },
                {
                    content: '3.86 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M208.455,322.995C188.89600000000002,302.586,171.20100000000002,280.385,155.579,256.697L3.098,403.555L0.767,523.503L208.455,322.995Z'
        },
        text: {
            transform: 'matrix(0.7193,-0.6947,0.6947,0.7193,164.611,450)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon',
                    dy: '-9.453125'
                },
                {
                    content: 'clone 10',
                    dy: '13.2',
                    x: '0'
                },
                {
                    content: '2.6 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
    {
        area: 3,
        path: {
            d: 'M109.286,166.611L6.914,207.381L3.099,403.553L155.57899999999998,256.697C137.066,228.629,121.475,198.466,109.286,166.611Z'
        },
        text: {
            transform: 'matrix(1,0,0,1,130,330)',
            tspan: [
                {
                    content: 'Cabernet Sauvignon',
                    dy: '-9.453125'
                },
                {
                    content: 'clone 06',
                    dy: '13.2',
                    x: '0'
                },
                {
                    content: '2.52 acres',
                    dy: '13.2',
                    x: '0'
                }
            ]
        }
    },
];